angular.module('logbook')
  .factory('tagStyle', [function() {
    var service = {};
    
    service.findTagStyle = function(tagValues)
    {
       var priority = null;
       var styles;
       var selectedTag = null;
       for( var i=0, tagValue; tagValue=tagValues[i]; i++)
       {
          var thisPriority = tagValue.priority || 0;
          var hasStyles = tagValue.styles && tagValue.styles.length;
          var isFirstWithStyles = styles == null && hasStyles;
          var noPrioritiesSeen = priority == null && tagValue.priority == null;
          
          if( isFirstWithStyles
               || thisPriority > priority
               || ((noPrioritiesSeen || thisPriority == priority) && hasStyles && tagValue.stringValue > selectedTag ))
          {
             priority = tagValue.priority;
             styles = tagValue.styles;
             selectedTag = tagValue.stringValue;
          }
       }
       if(styles)
          return styles.map(function(style) {
             return style.description;
          });

    };
    
    return service;
  }]);
